import React from 'react';
import { FormikProvider, useFormik, Form } from 'formik';
import {
  Layout, Button,
} from 'antd';
import { useHistory } from 'react-router-dom';
import { useActions } from '../../providers/actions-provider/actions.context';
import PageTitle from '../../lib/page-title';
import { createValidator } from '../../../utils/create-validator';
import { ChangePasswordDTO } from '../../../store/modules/user/dto/change-password.dto';
import FormControl from '../../lib/form-control';
import { ACCOUNT_PATH } from '../../routing/paths.constants';

const ChangePassword = (): JSX.Element => {
  const { userActions } = useActions();
  const { push } = useHistory();

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword: '',
    },
    onSubmit: (values) => {
      userActions.changePassword(values);
      push(ACCOUNT_PATH);
    },
    enableReinitialize: true,
    validate: (values: ChangePasswordDTO) => createValidator(ChangePasswordDTO, values),
  });

  return (
    <Layout className="main-container user-details">
      <PageTitle back title="Password" />
      <FormikProvider value={formik}>
        <Form className="formik-form">
          <FormControl name="oldPassword" label="Old password" type="password" />
          <FormControl name="newPassword" label="New password" type="password" />
          <Button htmlType="submit" type="primary" className="formik-form__submit">
            Save
          </Button>
        </Form>
      </FormikProvider>
    </Layout>
  );
};

ChangePassword.displayName = 'ChangePassword';

export default ChangePassword;
